import { render } from "./IconLock.vue?vue&type=template&id=7aad9b0f"
import script from "./IconLock.vue?vue&type=script&lang=ts"
export * from "./IconLock.vue?vue&type=script&lang=ts"
script.render = render

export default script